export const ROUTES = {
  HOME: '/',
};
